import * as React from 'react';
import { CustomRequestMap, DocAccessType } from '../../../../types';
import { Section } from '../../../Finger/Section';
import FingerWithApprove from '../../../atoms/finger-with-approve';
import NoDocuments from '../../../atoms/no-doc-placeholder';
import { getVisible, getFingerStatus, hasDeleted } from '../../../../utilities/documents';
import { UserRole } from '../../../../store/auth/types';
import { ICustomRequestDocList } from 'types';

interface IProps {
  userAccess?: DocAccessType;
  documents: CustomRequestMap;
  warning?: string;
  userRole?: UserRole;
  canUpload: boolean;
  canOpen: boolean;
  canApprove: boolean;
  canReject: boolean;
  isDeleting: boolean;
  onUploadClick: (customReqKey: string, docKey: string) => void;
  onOpenClick: (customReqKey: string, docKey: string) => void;
  onApproveClick: (customReqKey: string, docKey: string) => void;
  onRejectClick: (customReqKey: string, docKey: string) => void;
  onRescindRejectClick: (customReqKey: string, docKey: string) => void;
  onDeleteClick: (customReqKey: string, docKey: string) => void;
}

const CustomRequestDocument = (props: IProps) => {
  const { documents: customRequestDocuments = {}, userAccess, userRole } = props;
  let hasDocs = false;
  let hasDeletedDocs = false;
  const docNodes: React.ReactNode[] = [];

  const customRequestDocumentsKeys = Object.keys(customRequestDocuments).sort();
  customRequestDocumentsKeys.forEach(customReqKey => {
    const customDocs = customRequestDocuments[customReqKey];
    const visibleDocs = getVisible<CustomRequestMap, ICustomRequestDocList>({
      documentsHash: customDocs ?? {},
      userAccess,
      userRole,
    });
    if (hasDeleted(customDocs ?? {})) {
      hasDeletedDocs = true;
    }
    if (visibleDocs.length > 0) {
      hasDocs = true;
      docNodes.push(
        ...visibleDocs.map((doc, index) => {
          const { key, item } = doc;

          return (
            <FingerWithApprove
              id={`custom-doc-${customReqKey}-${key}`}
              key={`custom-doc-${customReqKey}-${key}`}
              status={getFingerStatus(item)}
              isProcessingPdf={item.isProcessingPdf}
              description={item?.desc ?? item.reason}
              reason={item.reason}
              fileCount={item.signedUrls && item.signedUrls.length > 0 ? item.signedUrls.length : 0}
              fileNames={item.fileNames}
              label={`${item.label} ${Object.keys(customDocs ?? {}).length > 1 ? (index > 0 ? index + 1 : '') : ''}`}
              canUpload={props.canUpload}
              canOpen={props.canOpen}
              canApprove={props.canApprove}
              canReject={props.canReject}
              isDeleting={props.isDeleting}
              canAcknowledge={false}
              onUploadClick={() => props.onUploadClick(customReqKey, key)}
              onOpenClick={() => props.onOpenClick(customReqKey, key)}
              onApproveClick={() => props.onApproveClick(customReqKey, key)}
              onRejectClick={() => props.onRejectClick(customReqKey, key)}
              onRescindRejectClick={() => props.onRescindRejectClick(customReqKey, key)}
              onDeleteClick={() => props.onDeleteClick(customReqKey, key)}
              onAcknowledgeClick={() => {}}
              userRole={props.userRole}
              deletedByTTL={item.deletedByTTL}
            />
          );
        }),
      );
    }
  });

  if (!hasDocs && !hasDeletedDocs) {
    return null;
  }

  if (userAccess && !hasDocs) {
    return null;
  }

  return (
    <Section key={`custom-request-section`} label={'Custom Request Document(s)'} warning={props.warning}>
      {hasDocs ? docNodes : <NoDocuments />}
    </Section>
  );
};

export default CustomRequestDocument;
